import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Input, Form, FormGroup, Label } from "reactstrap";
const Columns = (
  addUpd,
  destroy,
  active,
  items,
  setItems,
  duplicateBranch,
  setModalGeo,
  modalGeo,
  authUser,
  setModalUnits,
  modalRoute,
  setModalRoute
) => {
  const duplicate = async (row) => {
    const response = await duplicateBranch(row);
    if (response.status) {
      const newItem = response.branch;
      let array = [...items, newItem];
      array.sort((a, b) => {
        return a.id - b.id;
      });
      setItems(array);
    }
  };

  let columns = [
    {
      id: "clave",
      name: "Clave",
      selector: (row) => row.clave,
      sortable: true,
    },{
      id: "name",
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      id: "active",
      name: "Activo",
      width: "80px",
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <FormGroup switch>
            <Input
              type="switch"
              defaultChecked={row.active}
              onClick={() => {
                active(row);
              }}
            />
          </FormGroup>
        </div>
      ),
    },

    {
      id: "geofence",
      name: "Geocercas",
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Geocercas"
              onClick={() =>
                setModalGeo({ ...modalGeo, show: true, id: row.id })
              }
            >
              <i className="fa fa-th-list"></i>
            </button>
          </div>
        </div>
      ),
    },
    {
      id: "line",
      name: "Recorrido",
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Geocercas"
              onClick={() =>
                setModalRoute({ ...modalRoute, show: true, id: row.id })
              }
            >
              <i className=" fas fa-map-marked-alt"></i>
            </button>
          </div>
        </div>
      ),
    },
    {
      id: 'units',
      name: 'Unidades',
      width: "15%",
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Unidades"
              onClick={() =>
                setModalUnits(prev => ({ ...prev, show: true, id: row.id, route_id: row.route_id }))
              }
            >
              <i className="fa fa-bus"></i>
            </button>
          </div>
        </div>
      ),
    },
    {
      id: "actions",
      name: "Acciones",
      width: "15%",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="pe-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar ramal"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>
          <div className="pe-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar ramal"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
          <div className="pe-2">
            <button
              className="btn btn-primary btn-sm"
              title="Duplicar"
              onClick={() => duplicate(row)}
            >
              <i className="fa fa-clone"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];

  if (authUser.profile_id == 2) {
	columns = [
	  {
		id: "ruta",
		name: "Ruta",
		selector: (row) => row.route.name,
		sortable: true,
		wrap: true,
	  },
	  ...columns,
	];
  }

  return columns;
};

export default Columns;

//vaneton beicli
